<script>
    export let glassData = [];
    export let glassImages = {};
    //
    const layer1 = glassData[0];
    const gap1 = glassData[1];
    const layer2 = glassData[2];
    const gap2 = glassData[3];
    const layer3 = glassData[4];
</script>

<!-- <section id="ColRight"> -->
<section id="ColRight" class="user-select-none">
    <article class="PaneImages">
        <span id="ContentPlaceHolder1_tdImages">
            <img src={glassImages.LabelOutside} alt="Outside" title="Outside" />
            {#if layer1}
                <img src={layer1.Image} alt="Glass" title="Glass" class="tilt" />
            {/if}
            {#if layer2}
                <img src={layer2.Image} alt="Glass" title="Glass" class="tilt" />
            {/if}
            {#if layer3}
                <img src={layer3.Image} alt="Glass" title="Glass" class="tilt" />
            {/if}
            <img src={glassImages.LabelInside} alt="Inside" title="Inside" />
            &nbsp;&nbsp;&nbsp;
            <br style="clear: both" />

            {#if layer1}
                <img src={glassImages.DropLead} alt="Leader Line" class="DLine-Pane1" />
                <p class="Pane1"><span class="Name">{layer1.Title}</span></p>
                <p />
            {/if}
            {#if gap1}
                <img src={glassImages.UpLead} alt="Leader Line" class="DLine-Gas1" />
                <p class="Gas1">{gap1.Title}</p>
            {/if}
            {#if layer2}
                <img src={glassImages.DropLead2} alt="Leader Line" class="DLine-Pane2" />
                <p class="Pane2">
                    <span class="Coat" />
                    <br /><span class="Coat">{layer2.Title}</span>
                </p>
                <p />
            {/if}
            {#if gap2}
                <img src={glassImages.UpLead} alt="Leader Line" class="DLine-Gas2" />
                <p class="Gas2">{gap2.Title}</p>
            {/if}
            {#if layer3}
                <img src={glassImages.DropLead3} alt="Leader Line" class="DLine-Pane3" />
                <p class="Pane3">{layer3.Title}</p>
                <p />
            {/if}
            <!-- Color measurements surface -->
            <img src={glassImages.UpLead} alt="Leader Line" class="DLine-Gas1" style="left: 50px; top: 200px;" />
            <p style="position: absolute; left: 0px; top: 250px;">
                <span>Take color</span>
                <br/>
                <span>measurements</span>
                <br/>
                <span>on surface 1</span>
            </p>
        </span>
        <div class="ClearIt" />
    </article>
    <div>
        <span id="ContentPlaceHolder1_lblWarnings" />
    </div>
    <div class="ClearIt" />
</section>

<style>
</style>
